import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import i18n from 'i18n-js';
import {fontFamily} from '../../../helpers/fontFamily';
import {colors} from '../../../style/rulesEngine';
import {
  accentColor,
  dangerColor,
  groupBg,
  groupBorderColor,
  groupRadius,
  textColor,
  textMutedColor,
  toggleOffColor,
  touchButtonHeight,
  touchTargetMin
} from '../../../style/adminTools';
import {dangerTextOnDark} from '../../../style/adminTenantGrid';

const t = (key, options) => i18n.t(`adminTenantGrid.${key}`, options);

export const FailureBanner = ({onRetry, phone}) => (
  <View
    testID="tenantLoadFailedBanner"
    accessibilityRole="alert"
    style={{
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 12,
      paddingHorizontal: 14,
      paddingVertical: 10,
      backgroundColor: colors.dangerLight,
      borderWidth: 1,
      borderColor: dangerColor,
      borderRadius: 6
    }}
  >
    <Text
      style={{
        fontFamily: fontFamily.font500,
        fontSize: 14,
        color: dangerTextOnDark
      }}
    >
      {t('loadFailedBanner')}
    </Text>
    <TouchableOpacity
      testID="tenantBannerRetry"
      accessibilityRole="button"
      onPress={onRetry}
      style={
        phone
          ? {
              minWidth: touchTargetMin,
              minHeight: touchTargetMin,
              justifyContent: 'center',
              alignItems: 'center'
            }
          : undefined
      }
    >
      <Text
        style={{
          fontFamily: fontFamily.font700,
          fontSize: 14,
          color: accentColor
        }}
      >
        {t('retry')}
      </Text>
    </TouchableOpacity>
  </View>
);

export const PanelButton = ({label, onPress, primary, testID, block}) => (
  <TouchableOpacity
    testID={testID}
    accessibilityRole="button"
    onPress={onPress}
    style={{
      minHeight: block ? touchButtonHeight : 44,
      minWidth: 120,
      marginHorizontal: block ? 0 : 6,
      marginBottom: block ? 10 : 0,
      alignSelf: block ? 'stretch' : undefined,
      paddingHorizontal: 18,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 7,
      borderWidth: primary ? 0 : 2,
      borderColor: toggleOffColor,
      backgroundColor: primary ? accentColor : 'transparent'
    }}
  >
    <Text
      style={{fontFamily: fontFamily.font700, fontSize: 14, color: textColor}}
    >
      {label}
    </Text>
  </TouchableOpacity>
);

export const PanelFrame = ({testID, children, phone}) => (
  <View
    testID={testID}
    style={{
      alignItems: 'center',
      padding: phone ? 20 : 40,
      backgroundColor: groupBg,
      borderWidth: 1,
      borderColor: groupBorderColor,
      borderRadius: groupRadius
    }}
  >
    {children}
  </View>
);

export const Title = ({children}) => (
  <Text
    accessibilityRole="header"
    style={{
      fontFamily: fontFamily.font700,
      fontSize: 20,
      color: textColor,
      textAlign: 'center'
    }}
  >
    {children}
  </Text>
);

export const Body = ({children}) => (
  <Text
    style={{
      maxWidth: 520,
      marginTop: 8,
      marginBottom: 20,
      fontFamily: fontFamily.font500,
      fontSize: 14,
      lineHeight: 22,
      color: textMutedColor,
      textAlign: 'center'
    }}
  >
    {children}
  </Text>
);

export const FailurePanel = ({
  statusText,
  time,
  onRetry,
  onCopyDetails,
  phone
}) => (
  <PanelFrame testID="tenantLoadFailedPanel" phone={phone}>
    <View
      style={{
        width: 64,
        height: 64,
        marginBottom: 16,
        borderRadius: 32,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: colors.dangerLight
      }}
    >
      <Text style={{fontSize: 28, color: dangerTextOnDark}}>{'!'}</Text>
    </View>
    <Title>{t('loadFailedTitle')}</Title>
    <Body>{t('loadFailedBody', {status: statusText, time})}</Body>
    <View style={phone ? {alignSelf: 'stretch'} : {flexDirection: 'row'}}>
      <PanelButton
        primary
        block={phone}
        testID="tenantPanelRetry"
        label={t('retry')}
        onPress={onRetry}
      />
      <PanelButton
        block={phone}
        testID="tenantCopyErrorDetails"
        label={t('copyErrorDetails')}
        onPress={onCopyDetails}
      />
    </View>
  </PanelFrame>
);

export const EmptySearchPanel = ({query, count, onClear, phone}) => (
  <PanelFrame testID="tenantEmptySearchPanel" phone={phone}>
    <Title>{t('emptyTitle', {query})}</Title>
    <Body>{t('emptyBody', {count})}</Body>
    <PanelButton
      primary
      block={phone}
      testID="tenantEmptyClearSearch"
      label={t('clearSearch')}
      onPress={onClear}
    />
  </PanelFrame>
);

export const NoResultsPanel = ({phone}) => (
  <PanelFrame testID="tenantNoResultsPanel" phone={phone}>
    <Title>{t('noResults')}</Title>
  </PanelFrame>
);
